module.exports = __webpack_public_path__ + "img/geofisica_16-9_1920.ee3cff0d.jpg";